// extracted by mini-css-extract-plugin
module.exports = {"cp-modal-attributes__options__add":"styles_cp-modal-attributes__options__add__3gwEw","cp-modal-attributes__options__remove":"styles_cp-modal-attributes__options__remove__15GxZ"};